/* eslint-disable global-require */
/* eslint-disable max-len */
/**
 * About us页面配置
 */

export default {
  banner: {
    title: 'The Think Academy Mission',
    description: 'Think Academy is committed to fostering a passion for mathematics, help build our student\'s confidence, and help them gain a sense of accomplishment. Think Academy hopes that with us, every child can experience the joy of learning mathematics.',
    className: 'us-about-us-banner',
  },
  // 核心优势
  coreAdvantages: {
    title: 'Why Choose Think Academy?',
    advantages: [
      {
        name: 'Accelerated Growth',
        description: 'After taking a Think Academy class, your child will feel confident solving private school math curriculum at their current grade level.',
        picture: require('assets/images/index/quality-focussed-icon.png'),
      },
      {
        name: 'Improved Concentration',
        description: 'Think Academy parents tell us they see their kids’ focus and note taking skills increase—two essential skills for understanding new concepts and completing homework and tests.',
        picture: require('assets/images/index/goal-oriented-icon.png'),
      },
      {
        name: 'Engaging Online Classes',
        description: 'All Think Academy classes are fun, effective, and engaging thanks to our ThinkHub app. With ThinkHub, students can easily tune into our live stream classes and enjoy learning online with other Think Academy students.',
        picture: require('assets/images/index/technology-driven-icon.png'),
      },
    ],
  },
}
